<mat-divider class="divider-outline-variant"/>
<section class="side-menu-tab-group__tabs">
	<ng-content/>
</section>
<mat-divider class="divider-outline-variant"/>